import React from 'utils/react';
import { connect } from 'react-redux';
import withTranslation from 'utils/react/withTranslation';
import createImmutableSelector from 'utils/immutable-selector';

import { addBookingToRoute } from 'modules/commuteOffer/actions';
import { commuteOfferIsReadOnlySelector } from 'modules/commuteOffer/selectors';
import {
  flyToCommuteOfferActiveStop,
  flyToCommuteOfferActiveBooking,
} from 'modules/maps/actions';
import { currentProjectLayoutNameSelector } from 'modules/user/selectors';
import { activeBookingIdSelector } from 'modules/ui/selectors';

import {
  setActiveVehicleId,
  setActiveRouteStop,
  setActiveBookingId,
  setEditableBookingId,
  cleanActiveBookingId,
} from 'modules/ui/actions';

import Booking from './Booking';
import DraggableBooking from './DraggableBooking';

const mapStateToProps = createImmutableSelector(
  activeBookingIdSelector,
  commuteOfferIsReadOnlySelector,
  currentProjectLayoutNameSelector,
  (activeBookingId, isReadOnly, layoutName) => ({
    activeBookingId,
    isReadOnly,
    layoutName,
  })
);

const mapDispatchToProps = {
  addBookingToRoute,
  setActiveVehicleId,
  setActiveRouteStop,
  setActiveBookingId,
  setEditableBookingId,
  flyToCommuteOfferActiveStop,
  flyToCommuteOfferActiveBooking,
  cleanActiveBookingId,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const Component = props =>
  props.isReadOnly ? <Booking {...props} /> : <DraggableBooking {...props} />;

export default withConnect(withTranslation()(Component));
